import React, { useState } from "react";

import {
    CompareTileBlock,
    TsicommonCmsCompareTileOrNull,
    templates,
} from "@reactivated";

import { CompareGrid } from "../apps/shop-compare/CompareGrid";
import { CompareTileType } from "../apps/shop-compare/ShopCompareTypes";

export type CompareTileWithDisabled = TsicommonCmsCompareTileOrNull & {
    disabled: boolean;
};

export type CompareTileBlockWithDisabled = CompareTileBlock & {
    compare_tile: CompareTileWithDisabled;
};

export type DropdownHeadersType = {
    header: string | undefined;
    id: number | undefined;
    children: CompareTileBlockWithDisabled[] | undefined;
}[];

export const Template = (props: templates.ShopTileTemplate) => {
    const [selectedCompareTiles, setSelectedCompareTiles] = useState<number[]>(
        props.shop_tile.compare_tiles.value
            .slice(0, 3)
            .map((t) => t.value.compare_tile?.product || 0),
    );
    if (!props.tileset?.shop_tiles || !props.shop_tile) {
        return null;
    }
    const compareTiles: CompareTileType[] =
        props.tileset.shop_tiles.value.reduce((acc, t) => {
            const tile = t.value.shop_tile;
            acc.push(
                ...(tile?.compare_tiles?.map(
                    (ct) => ct.value as CompareTileType,
                ) || []),
            );
            return acc;
        }, [] as CompareTileType[]);
    const dropdownHeaders: DropdownHeadersType =
        props.tileset.shop_tiles.value.map((t) => {
            const tile = t.value.shop_tile;
            if (!tile) {
                return {
                    header: "",
                    id: undefined,
                    children: [],
                };
            }
            return {
                header: tile.custom_header_name ?? tile.title,
                id: tile.product || undefined,
                category: tile.category,
                children: tile.compare_tiles?.map((t) => ({
                    ...t.value,
                    compare_tile: {
                        ...t.value.compare_tile,
                        disabled: t.value.compare_tile?.product
                            ? selectedCompareTiles.includes(
                                  t.value.compare_tile.product,
                              )
                            : true,
                    },
                })),
            };
        });
    const handleSelectProductTile = (oldTile: number, newTile: number) => {
        if (oldTile <= 0) {
            setSelectedCompareTiles((prev) => [...prev, newTile]);
            return;
        }
        const selectedCompareTilesCopy = [...selectedCompareTiles];
        const oldTileIndex = selectedCompareTilesCopy.findIndex(
            (t) => t === oldTile,
        );
        if (oldTileIndex !== -1) {
            selectedCompareTilesCopy.splice(oldTileIndex, 1, newTile);
            setSelectedCompareTiles(selectedCompareTilesCopy);
        }
    };
    return (
        <div>
            <CompareGrid
                compareTiles={compareTiles}
                compareFeatures={
                    props.tileset.compare_features?.value.map(
                        (cf) => cf.value,
                    ) || []
                }
                dropdownHeaders={dropdownHeaders}
                handleSelectProduct={handleSelectProductTile}
                selectedProducts={selectedCompareTiles}
            />
        </div>
    );
};
